import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { DateTime } from 'luxon'
import { useSelector } from 'react-redux'
import TranspotsLoading from 'components/transpots-loading/transpots-loading.component'
import { RootState } from 'store'
import { useGetEquipmentHistoryQuery } from 'store/equipments/equipments.api'

const formatHistoryDate = (date: string) => {
  const parsed = DateTime.fromISO(date)
  return parsed.isValid ? parsed.toFormat('MMM dd, yyyy') : ''
}

const EquipmentHistory = () => {
  const { selectedEquipment } = useSelector(
    (state: RootState) => state.equipments
  )

  const { data: history, isLoading } = useGetEquipmentHistoryQuery(
    {
      equipmentId: selectedEquipment.equipmentId,
      equipmentType: selectedEquipment.equipmentType,
    },
    { skip: selectedEquipment.equipmentId === 0 }
  )

  if (selectedEquipment.equipmentId === 0) {
    return (
      <Box p={2}>
        <Typography variant="body2" fontWeight={600}>
          Please select equipment to see history.
        </Typography>
      </Box>
    )
  }

  if (isLoading) {
    return <TranspotsLoading />
  }

  return (
    <TableContainer component={Paper} sx={{ borderRadius: 0 }}>
      <Table>
        <TableHead>
          <TableRow sx={{ bgcolor: 'secondary.light' }}>
            <TableCell sx={{ fontWeight: 700 }}>Date</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Trip ID</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Address</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {history?.map((entry) => (
            <TableRow
              key={`${entry.tripId}-${entry.date}`}
              sx={{ bgcolor: 'secondary.light' }}
            >
              <TableCell>
                <Typography color="primary.main">
                  {formatHistoryDate(entry.date)}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography>{entry.userTripId}</Typography>
              </TableCell>
              <TableCell>
                <Typography>{entry.address}</Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default EquipmentHistory
